<template>
  <div></div>
</template>

<script>

export default {
  name: 'PlayerPendingAddDataInputForceApplyMigration',

  methods: {
    fillFormData() {
      return null;
    },
  },
}
</script>
